import { createStructuredSelector } from 'reselect';
import {
  selectedServicesSelector,
  presentationalOfficesSelector,
} from '@selectors/filterServicesSelector';
import { servicesCatalogSelector } from '@selectors/servicesCatalogSelector';
import {
  legendVisibilitySelector,
  mobileMapVisibilitySelector,
} from '@selectors/uiSelector';
import { routeSelectedSelector } from '@selectors/routesSelector';
import { mfcSelector, nearestMfcSelector } from '@selectors/mfcSelector';
import { dataSelector } from '@selectors/dataSelector';

export const structuredSelector = createStructuredSelector<any, any>({
  legendOpened: legendVisibilitySelector,
  mobileMapOpened: mobileMapVisibilitySelector,
  routeSelected: routeSelectedSelector,
  selectedMfc: mfcSelector,
  selectedServices: selectedServicesSelector,
  servicesCatalog: servicesCatalogSelector,
  presentationalOffices: presentationalOfficesSelector,
  nearestMfc: nearestMfcSelector,
  data: dataSelector,
});

export type StructuredSelectorProps = {
  legendOpened?: boolean;
  mobileMapOpened?: boolean;
  routeSelected?: any;
  selectedMfc?: any;
  selectedServices?: any;
  servicesCatalog?: any;
  presentationalOffices?: [number];
  nearestMfc?: number | any;
  data?: any;
};
